<script setup>
import { useFVStore} from "./stores/formvibes";
import Settings from './Components/Settings/settings.vue';

const store = useFVStore();

</script>

<template>
    <el-config-provider>
      <div>
        <Settings :store="store" />
      </div>
  </el-config-provider>
</template>

<style scoped>

</style>
